import { StyleSheet } from 'react-native';

export const createStyles = () =>
    StyleSheet.create({
        // 商品信息区域
        goodsInfoContainer: {
            flexDirection: 'row',
            paddingHorizontal: 16,
            paddingTop: 20,
            paddingBottom: 16,
        },
        goodsImage: {
            width: 100,
            height: 100,
            borderRadius: 8,
            backgroundColor: '#F5F5F5',
        },
        goodsInfoRight: {
            flex: 1,
            marginLeft: 12,
            justifyContent: 'center',
        },
        priceRow: {
            flexDirection: 'row',
            alignItems: 'baseline',
        },
        priceCurrency: {
            fontSize: 16,
            color: '#FF4D4F',
            fontWeight: 'bold',
        },
        priceInteger: {
            fontSize: 28,
            color: '#FF4D4F',
            fontWeight: 'bold',
            lineHeight: 34,
        },
        priceDecimal: {
            fontSize: 16,
            color: '#FF4D4F',
            fontWeight: 'bold',
        },
        originalPrice: {
            fontSize: 13,
            color: '#999999',
            textDecorationLine: 'line-through',
            marginLeft: 8,
        },
        goodsCode: {
            fontSize: 13,
            color: '#999999',
            marginTop: 6,
        },
        goodsTitle: {
            fontSize: 14,
            color: '#333333',
            marginTop: 4,
            lineHeight: 20,
        },

        // 分割线
        divider: {
            height: StyleSheet.hairlineWidth,
            backgroundColor: '#F0F0F0',
            marginHorizontal: 16,
        },

        // 属性区域
        attributeSection: {
            paddingHorizontal: 16,
            paddingTop: 16,
            paddingBottom: 8,
        },
        attributeTitle: {
            fontSize: 15,
            fontWeight: 'bold',
            color: '#333333',
            marginBottom: 12,
        },

        // 数量区域
        quantitySection: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingHorizontal: 16,
            paddingVertical: 16,
        },
        quantityTitle: {
            fontSize: 15,
            fontWeight: 'bold',
            color: '#333333',
        },

        // 底部操作区域
        footer: {
            paddingHorizontal: 16,
            paddingTop: 12,
            paddingBottom: 20,
        },
        footerButtons: {
            flexDirection: 'row',
            gap: 12,
        },
        addCartButton: {
            flex: 1,
        },
        confirmButton: {
            flex: 1,
        },

        // 关闭按钮
        closeButton: {
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 10,
            padding: 4,
        },

        // 滚动内容
        scrollContent: {
            maxHeight: '70%' as unknown as number,
        },
    });
